// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import {
    Divider,
    IconButton,
    Tooltip,
    Fab
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../icon';
import apiUrl from '../../../configs/constant';
import MsiDatagrid from '../../custom/MsiDatagridAuto';

import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token

    // ** State

    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))

    const [listData, setListData] = useState<any[]>([])

    useEffect(() => {
        getData()
    }, [])

    const navigate = useNavigate();

    const getData = () => {
        setListData([])
        // Swal.fire({
        //     title: 'Now loading',
        //     allowEscapeKey: false,
        //     allowOutsideClick: false,
        //     didOpen: () => {
        //         Swal.showLoading()
        //     }
        // })

        // let url = apiUrl.apiUrl + '/sales/sales-order/list'

        // axios
        //     .get(url, {
        //         params: {
        //             awal: tglAwal,
        //             akhir: tglAkhir,
        //             mode: mode,
        //         },
        //         headers: { Authorization: `Bearer ${token}` }
        //     })
        //     .then(response => {
        //         if (response.data.success) {
        //             const data = response.data.data
        //             setListData(data)
        //             Swal.close()
        //         } else {
        //             Swal.fire({
        //                 title: 'Pemberitahuan',
        //                 text: response.data.message,
        //                 icon: 'error'
        //             })
        //         }
        //     })
    }

    const handleDelete = (row: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin hapus data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Hapus'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/sales/sales-order/delete/' + row.id
                axios
                    .delete(url, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getData()
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    };

    const ActionButtons = ({ row, onDelete, onNavigate }: {
        row: any;
        onDelete: (row: any) => void;
        onNavigate: (id: string) => void
    }) => {
        const actions = [
            {
                title: "Lihat Detail",
                icon: "mdi:search",
                color: "primary",
                onClick: () => onNavigate(row.id)
            },
            {
                title: "Hapus Sales Order",
                icon: "mdi:trash",
                color: "red",
                onClick: () => onDelete(row)
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                    onNavigate={(id) => navigate('/sales/sales-order/detail/' + id)}
                />
            ),
        },
    ];

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <Divider />
                <Box
                    sx={{
                        mt: 2,
                        width: '100%',
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    }}
                >
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                        {/* <CardHeader title='SALES ORDER' /> */}
                    </Box>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                        {/* <Fab color='primary' size='medium' onClick={() => navigate('/sales/sales-order/add')} */}
                        <Fab color='primary' size='medium'>
                            <Icon icon='mdi:plus' fontSize={35} color='white' />
                        </Fab>
                    </Box>
                </Box>
                <Box>
                    <Grid
                        container
                        sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}
                        spacing={5}
                    >
                        <Grid item xs={12} md={3}>
                            <FormControl fullWidth>
                                <TextField
                                    label='Tanggal Awal'
                                    type='date'
                                    onChange={(e) => setTglAwal(e.target.value)}
                                    value={tglAwal}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <FormControl fullWidth>

                                <TextField
                                    label='Tanggal Akhir'
                                    type='date'
                                    onChange={(e) => setTglAkhir(e.target.value)}
                                    value={tglAkhir}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <FormControl fullWidth>
                                <Button
                                    variant='contained'
                                    sx={{ mt: 1 }}
                                    startIcon={<Icon icon='mdi:magnify' />}
                                    onClick={() => getData()}
                                >
                                    Cari Data
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Box>
                <MsiDatagrid array={listData} actions={actionData} />
            </Grid>
        </Grid>
    )
}
